import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import ErrorReporting from 'material-ui-error-reporting';

const ChevronLeft = require('react-icons/lib/md/chevron-left');
const DoneAll = require('react-icons/lib/md/done-all');
const Search = require('react-icons/lib/md/search');

const style = {
  margin: 12,
};

const contentStyle = {
  margin: 20,
  textAlign: 'left',
  display: 'inline-block',
};

/*
 * Dieser Style sorgt dafür, dass beim Ausblenden der Buttons und das Einblenden des Spinners die Höhe des divs
 * erhalten bleibt und die Oberfläche nicht anfängt zu flickern.
*/
const buttonDivStyle = {
  height: 110,
};

class Zusammenfassung extends Component {
  render() {
    const {
      statusCode,
      error,
      errorText,
      transmitting,
      onSubmit: handleSubmit,
      onBack: handleBack,
      parentValue,
      childrenValues,
      disabled,
      viewportWidth,
      beitragSumme,
    } = this.props;

    return (
      <div>
        <ErrorReporting
          open={error}
          getMessage={ (props) => `${statusCode}: ${errorText}` }
        />
        <h1>Ratzgiwatz Jugendprogramm Web-Anmeldung</h1>
        <h3>Zusammenfassung.</h3>
        <Search size={60}/>
        <br/>
        <div className="text" style={contentStyle}>
          Bitte kontrollieren Sie die von Ihnen eingegebenen Daten auf Vollständigkeit:
          <br />
          <h4>Daten des Erziehungsberechtigten</h4>
          <table>
            <tbody>
              <tr>
                <td>Name:</td>
                <td>{parentValue.get('vorname')} {parentValue.get('nachname')}</td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td>{parentValue.get('email')}</td>
              </tr>
              <tr>
                <td>Strasse:</td>
                <td>{parentValue.get('strasse')}</td>
              </tr>
              <tr>
                <td>Wohnort:</td>
                <td>{parentValue.get('plz')} {parentValue.get('ort')}</td>
              </tr>
              <tr>
                <td>Telefon privat:</td>
                <td>{parentValue.get('telefonPrivat')}</td>
              </tr>
              <tr>
                <td>Telefon mobil:</td>
                <td>{parentValue.get('telefonMobil')}</td>
              </tr>
              <tr>
                <td>Telefon geschäftlich:</td>
                <td>{parentValue.get('telefonGeschaeftlich')}</td>
              </tr>
              <tr>
                <td>E-Mail unter der Woche:</td>
                <td>{parentValue.get('einverstaendnisWaehrendDerWoche') ? "Ja" : "Nein"}</td>
              </tr>
            </tbody>
          </table>
          <div>
            {
              childrenValues.sort((a, b) => a.get('kindNr') - b.get('kindNr')).entrySeq().map(function (entry) {
                let key = entry[0];
                let value = entry[1];
                return <div key={key}>
                  <h4>Kind {key}</h4>
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td>Name:</td>
                          <td>{value.get('vorname')} {value.get('nachname')}</td>
                        </tr>
                        <tr>
                          <td>Geschlecht:</td>
                          <td>{value.get('geschlecht')}</td>
                        </tr>
                        <tr>
                          <td>Geburtsdatum:</td>
                          <td>{value.get('geburtsdatum')}</td>
                        </tr>
                        <tr>
                          <td>T-Shirt Größe:</td>
                          <td>{value.get('tshirtGroesseText')}</td>
                        </tr>
                        <tr>
                          <td>Tetanus-Impfung vorhanden:</td>
                          <td>{value.get('tetanusImpfungVorhanden', false) ? 'ja' : 'nein'}</td>
                        </tr>
                        <tr>
                          <td>bekannte Unverträglichkeiten:</td>
                          <td>{value.get('allergien') || 'keine Angabe'}</td>
                        </tr>
                        <tr>
                          <td>Aktion:</td>
                          <td>{value.get('sonstiges') || 'keine Angabe'}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <br/>
                </div>;
              })
            }
          </div>
        </div>
        <br/>
        { !transmitting && viewportWidth > 300 && <div style={buttonDivStyle}><RaisedButton
          style={style}
          label="Daten korrigieren"
          onTouchTap={handleBack}
          icon={<ChevronLeft/>}
        /><RaisedButton
          style={style}
          label="Anmeldung abschließen"
          onTouchTap={handleSubmit}
          primary={true}
          disabled={disabled}
          icon={<DoneAll/>}
        /></div>
        }
        { !transmitting && viewportWidth <= 300 && <div style={buttonDivStyle}><RaisedButton
          style={style}
          label="Korrektur"
          onTouchTap={handleBack}
          icon={<ChevronLeft/>}
        /><RaisedButton
          style={style}
          label="Abschließen"
          onTouchTap={handleSubmit}
          primary={true}
          disabled={disabled}
          icon={<DoneAll/>}
        /></div>
        }
        { transmitting && <div style={buttonDivStyle}><CircularProgress/></div> }
      </div>
    );
  }
}

export default Zusammenfassung



// WEBPACK FOOTER //
// ./src/components/zusammenfassung/Zusammenfassung.jsx